<template>
  <div class="gx-modal" v-if="visible" @click="visible=false">
    <div class="gx-modal-box gx-modal-box--sm">
      <div class="gx-modal-head gx-modal-head--gray">
        <div class="gx-modal-title">提示</div>
      </div>
      <div class="gx-modal-body acea-col">
        <div class="warning-icon">!</div>
        <div class="warning-tip">功能开发中，敬请期待</div>
        <button class="opt-btn" @click="visible=false">知道了</button>
      </div>

    </div>

  </div>

</template>
<script>
export default {
  data(){
    return {
      visible:false
    }
  },
  methods:{
    show(){
      this.visible  = true
    }
  }
}
</script>


<style scoped>
.acea-col{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.gx-modal-box--sm{
  max-width: 380px;
}
.warning-icon{
  display: flex;
  width: 52px;
  height: 52px;
  align-items: center;
  justify-content: center;
  border: 2px solid #ffd666;
  border-radius: 50%;
  background: #fffbe6;
  color: #c8443c;
  font-size: 28px;
}
.warning-tip{
  font-family: "Noto Serif SC", serif;
  font-size: 18px;
  font-weight: 700;
  color: rgb(26, 26, 46);
  margin-top: 8px;
}
.opt-btn{
  margin-top: 24px;
  width: 120px;
  height: 32px;
  border: 0;
  border-radius: 6px;
  background: #1677ff;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
}
</style>
